import { SingleTableBoxScene } from "@/shared/components/ui";
import TableCuadreTecnico from "../../shared/componente/table-cuadre-tecnico/TableCuadreTecnico";

export default function CuadreTecnicoPage() {

  return (
    <SingleTableBoxScene title={"Cuadre Técnico"}
      py={2}
      visibleReport={true}
    >
      <TableCuadreTecnico />


    </SingleTableBoxScene >
  )

}